import './App.css';
import Language from './components/Language';

function App() {

    const languages = [
        {
            icon:"https://img.icons8.com/color/48/java-coffee-cup-logo--v1.png",
            name:"Java",
            desc:"Over 3 years of Game and Web Systems development experience in Java",
            projects:[
                {
                    name:"AST Parser",
                    desc:"Regex-like no-code AST and parser generator",
                    url:{
                        "Github Repository": "https://github.com/Kari3600/ast-parser-compiler"
                    }
                },
                {
                    name:"MinecraftFisher",
                    desc:"Annotation-based framework for creating Bukkit plugins using Java",
                    url:{
                        "Github Repository": "https://github.com/Kari3600/MinecraftFisher"
                    }
                },
                {
                    name:"RapidSerializer",
                    desc:"Annotation-based serializer generator for Java objects, intended for packet payload serialization",
                    url:{
                        "Github Repository": "https://github.com/Kari3600/RapidSerializer"
                    }
                },
                {
                    name:"3D Multiplayer MOBA Game",
                    desc:"A sketch of a 3D multiplayer MOBA game with own 3d graphics engine and event based synchronization system",
                    url:{
                        "Github Repository": "https://github.com/Kari3600/TestGameRepo"
                    }
                },
                {
                    name:"BlazeMC, Netherstorm, Eternal",
                    desc:"Minecraft networks projects, consisting of multiple servers communicating with each other, database management system with custom serializer, webpages, system monitoring and more",
                    url:{}
                }
            ]
        },
        {
            icon:"https://img.icons8.com/color/48/javascript--v1.png",
            name:"JavaScript",
            desc:"Experienced in Single Page Applications using Node and React",
            projects:[
                {
                    name:"Portfolio Website",
                    desc:"This very website, built using React and hosted on GitHub Pages",
                    url:{
                        "Github Repository": "https://github.com/Kari3600/portfolio"
                    }
                }
            ]
        },
        {
            icon:"https://img.icons8.com/color/48/c-plus-plus-logo.png",
            name:"C++",
            desc:"Basic experience in C++, mostly in implementing algorithms and data structures when high efficiency was mandatory" 
        },
        {
            icon:"https://img.icons8.com/color/48/lua-language.png",
            name:"Lua",
            desc:"The first language I learned, developing games in Roblox Studio since 2015"
        },
        {
            icon:"https://img.icons8.com/color/48/python--v1.png",
            name:"Python",
            desc:"Used for multiple academic projects in a broad range of subjects from Artificial Intelligence, Software Engineering and Data Analysis",
            projects:[
                {
                    name:"Markush structure parser",
                    desc:"Parsing Markush structures from patent documents and storing them in a custom format for querying and analysis. Result of my team's work for RYVU under Non Disclosure Agreement",
                    url:{
                        "Ryvu": "https://ryvu.com/pl"
                    }
                }
            ]
        }
    ]

    return (
        <div className="App">
            <header>
                
                <h2>Hi, I'm Karol</h2>
                <h1>Software Developer</h1>
                <p>
                    I am specializing in game development, web applications and creating/extending frameworks, mainly in Java<br/>
                    I highly value clean design, maintainability, and scalability in projects I'm working on.
                </p>
                <p>
                    I'm currently studying Artificial Intelligence at the Poznan University of Technology.
                </p>
                <p>
                    In my free time, besides programming, I workout and play instruments
                </p>
            </header>
            {languages.map((language) => (
                <Language data={language}/>
            ))}
        </div>
    );
}

export default App;
